import { Box, Toolbar, Tooltip, Dialog, DialogContent, DialogTitle, DialogActions, Tabs, Tab, Button, Checkbox, FormControlLabel, FormGroup, TextField, Autocomplete, Chip, createFilterOptions, Select, MenuItem } from '@mui/material';
import CentralizedTable from '../components/CentralizedTable';
import axios from 'axios';
import moment from 'moment';
import TailwindModal from '../components/TailwindModal';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import MuiLink from "@mui/material/Link";
import { notify } from '../utils/ToastUtils';
import Card from 'src/components/Card';
import ActionConfirmModal from '../components/ActionConfirmModal';
import LoaderIcon from '../components/LoaderIcon';

import ReactDOMServer from 'react-dom/server';
import html2pdf from 'html2pdf.js/dist/html2pdf.min';
import img from '../../src/images/DAFullLogo.png';
import onlyLogo from '../../src/images/OnlyLogo.png';
import footerimg from '../../src/images/NameLogo.png'
import InternOfferLetter from '../letters/InternOfferLetter';
import OfferLetter from '../letters/OfferLetter';
import { selectEmployees } from 'src/stores/employeeSlice';
import { useSelector } from 'react-redux';
import { FiEdit2, FiTrash2, FiEye, FiCheck, FiX, FiInfo, FiCopy, FiDownload } from 'react-icons/fi';
import { Users, Settings, Plus, Send, CheckCircle, FileText, FileSignature, Trash2, CircleAlert, Save, Mail } from 'lucide-react';
import ProvisionalOfferLetter from '../letters/ProvisionalOfferLetter';
import ManageRoleConfigurations from './ManageRoleConfigurations';
import SharedCandidateInfo from '../components/SharedCandidateInfo';
import { MANAGERS, ROLES, LOCATIONS } from '../utils/constants';

const filter = createFilterOptions();


const initialState = {
    Name: "",
    Mail: "",
    number: "",
    reportingManager: "",
    dateOfJoin: "",
    exitDate: "",
    intern_code: "",
    type: "Intern",
    location: ""
}
function InternHr({ onNavigateToLetter }) {
    const [state, setState] = useState(initialState)
    const [submitAttempted, setSubmitAttempted] = useState(false);
    
    const [rows, setRows] = useState([])
    const employees = useSelector(selectEmployees);
    const [preview, setPreview] = useState(null);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewError, setPreviewError] = useState("");
    const [loadingState, setLoadingState] = useState({ pageLoading: false, emailSending: false, deleteLoading: false, actionLoadingId: null, actionType: null });
    const [selectedRow, setSelectedRow] = useState(null);
    const [emailDetails, setEmailDetails] = useState({
        toEmail: "",
        hrName: "",
        hrEmail: "",
        hrMobile: "",
        subject: "Welcome to the team! Your onboarding starts here",
        link: "",
        template: "",
        countryCode:"+91",
        ccEmails: []
    });
    
    // Configurations Tab States
    const [activeTab, setActiveTab] = useState(0);
    const [previewAttachments, setPreviewAttachments] = useState([]);
    const [copiedLinks, setCopiedLinks] = useState({});
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [candidateToDelete, setCandidateToDelete] = useState(null);
    const [selectedCandidateDetails, setSelectedCandidateDetails] = useState(null);
    
    const handleCopyLink = (row) => {
        const path = row.LOCATION !== "US" ? `/onboarding/${row.LINK_ID}` : `/us-onboarding/${row.LINK_ID}`;
        navigator.clipboard.writeText(`${window.location.origin}${path}`);
        setCopiedLinks(prev => ({ ...prev, [row.LINK_ID]: true }));
        setTimeout(() => {
            setCopiedLinks(prev => ({ ...prev, [row.LINK_ID]: false }));
        }, 500);
    };

    const handleDeleteClick = (row) => {
        setCandidateToDelete(row);
        setDeleteModalOpen(true);
    };

    const handleVerify = async (row) => {
        setLoadingState(prev => ({ ...prev, actionLoadingId: row.ID, actionType: 'verify' }));
        await new Promise(resolve => setTimeout(resolve, 50));
        setSelectedCandidateDetails({ token: row?.LINK_ID, location: row?.LOCATION, isViewOnly: false });
        setLoadingState(prev => ({ ...prev, actionLoadingId: null, actionType: null }));
    };

    const handleViewFiles = async (row) => {
        setLoadingState(prev => ({ ...prev, actionLoadingId: row.ID, actionType: 'view' }));
        await new Promise(resolve => setTimeout(resolve, 50));
        setSelectedCandidateDetails({ token: row?.LINK_ID, location: row?.LOCATION, isViewOnly: true });
        setLoadingState(prev => ({ ...prev, actionLoadingId: null, actionType: null }));
    };

    const handleLetterClick = async (row) => {
        setLoadingState(prev => ({ ...prev, actionLoadingId: row.ID, actionType: 'letter' }));
        await new Promise(resolve => setTimeout(resolve, 50));
        try {
            if (row?.TYPE === "Intern") await InternOffer(row?.LINK_ID);
            else if (row?.TYPE === "Employee") await EmpOfferLetter(row?.LINK_ID);
            else await ProOfferLetter(row?.LINK_ID);
        } finally {
            setLoadingState(prev => ({ ...prev, actionLoadingId: null, actionType: null }));
        }
    };

    const handleDeleteClickWithLoader = async (row) => {
        setLoadingState(prev => ({ ...prev, actionLoadingId: row.ID, actionType: 'delete' }));
        await new Promise(resolve => setTimeout(resolve, 50));
        setCandidateToDelete(row);
        setDeleteModalOpen(true);
        setLoadingState(prev => ({ ...prev, actionLoadingId: null, actionType: null }));
    };

    const confirmDeleteCandidate = async () => {
        if (!candidateToDelete) return;
        setLoadingState(prev => ({ ...prev, deleteLoading: true }));
        try {
            await axios.delete(`${process.env.REACT_APP_BASE_URL}/admin/deleteCandidate?id=${candidateToDelete.ID}`);
            notify.success("Candidate deleted successfully");
            setDeleteModalOpen(false);
            setCandidateToDelete(null);
            getQueries();
        } catch (error) {
            console.log(error);
            let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Failed to delete candidate";
            notify.error(errmsg);
        } finally {
            setLoadingState(prev => ({ ...prev, deleteLoading: false }));
        }
    };


    function handleChange(evt) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value
        });
    }


    const printHandler = (content, pdfName) => {
        const printElement = ReactDOMServer.renderToString(content);
        // const printElement = pdfJSX();
        const opt = {
            margin: [30, 10, 30, 10],
            filename: `${pdfName}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            html2canvas: { dpi: 75, scale: 2, letterRendering: true },
            // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
            pagebreak: { before: '.pagebreakneed', avoid: ['img', 'table', 'p', 'tr', 'th'] }
        };
        const pageBreakElements = document.getElementsByClassName('page-break');
        for (let i = 0; i < pageBreakElements.length; i++) {
            pageBreakElements[i].style.pageBreakBefore = 'always';
        }
        html2pdf().from(printElement).set(opt).toPdf().get('pdf').then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            const pageWidth = pdf.internal.pageSize.getWidth();

            // Line 1 parts
            const line1Parts = [
            { text: 'D', color: '#961a1d' },
            { text: '-ACES', color: '#FCCC0B' },
            { text: ' INDIA PRIVATE LIMITED ', color: 150 },
            { text: ' |', color: '#961a1d' },
            { text: ' Gateway Office Parks - Block B6 - First Floor ', color: 150 },
            { text: '|', color: '#961a1d' },
            { text: ' 16 GST Road ', color: 150 },
            { text: '|', color: '#961a1d' },
            { text: ' Perungalathur', color: 150 }
            ];

            // Line 2 parts
            const line2Parts = [
            { text: ' Chennai 600063 ', color: 150 },
            { text: '|', color: '#961a1d' },
            { text: ' INDIA', color: 150 }
            ];

            // Helper to draw colored and centered text line
            const drawColoredLine = (pdf, parts, y) => {
            const totalWidth = parts.reduce((sum, part) => sum + pdf.getTextWidth(part.text), 0);
            let x = (pageWidth - totalWidth) / 2;

            parts.forEach(part => {
            pdf.setTextColor(part.color);
            pdf.text(part.text, x, y);
            x += pdf.getTextWidth(part.text);
            });
            };

            for (let i = 1; i <= totalPages; i++) {
                // set footer to every page
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setFont('helvetica');

                const y1 = pdf.internal.pageSize.getHeight() - 13;
                const y2 = pdf.internal.pageSize.getHeight() - 7;

                // Draw colored, centered footer lines
                drawColoredLine(pdf, line1Parts, y1);
                drawColoredLine(pdf, line2Parts, y2);

                // Add images (centered)
                pdf.addImage(onlyLogo, 'png', (pageWidth - 30) / 2, 5, 30, 20);
                pdf.addImage(footerimg, 'png', (pageWidth - 32) / 2, pdf.internal.pageSize.getHeight() - 27, 32, 5);
  
                // // pdf.addImage(img, 'png', 80, 5, 45, 13)
                // // pdf.addImage(footerimg, 'png', 90, pdf.internal.pageSize.getHeight() - 30, 32, 5)
                // pdf.addImage( onlyLogo, 'png', 90, 5, 30, 20)
                // pdf.addImage(footerimg, 'png', 90, pdf.internal.pageSize.getHeight() - 30, 32, 5)
            }
        }).save();
    }

    const handleAddCandiate = async () => {
        setSubmitAttempted(true);
        if (state.Name && state.Mail && state.number && state.intern_code && state.reportingManager && state.dateOfJoin && state.location && state.type) {
            setLoadingState(prev => ({ ...prev, addCandidateLoading: true }));
            try {
                await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/newIntern`, {
                    name: state.Name,
                    mail: state.Mail,
                    number: state.number,
                    manager: state.reportingManager,
                    joiningDate: state.dateOfJoin,
                    exit: state.exitDate,
                    intern_code: state.intern_code,
                    type: state.type,
                    location: state.location,
                    submission: moment(new Date()).format("YYYY-MM-DD")
                })
                notify.success("Added new Candidate Successfully!");
                setState(initialState);
                setSubmitAttempted(false);
                getQueries();
            }
            catch (error) {
                console.log(error)
                let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later"
                notify.error(errmsg)
            }
            finally {
                setLoadingState(prev => ({ ...prev, addCandidateLoading: false }));
            }
        }
    }


    const getQueries = async () => {
        try {
            setLoadingState(prev => ({ ...prev, pageLoading: true }));
            const { data } = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/getIntern`)
            var currentCandidate = data
            setRows(currentCandidate)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingState(prev => ({ ...prev, pageLoading: false }));
        }
    }

    const downloadFile = async (fileName) => {
        const fileUrl = `${process.env.REACT_APP_PUBLIC_URL}/public/onboarding_attachments/${fileName}`;
        try {
            const response = await fetch(fileUrl);
            if (!response.ok) throw new Error("File not found or CORS blocked");
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    const handleOpenPreview = async (row) => {
        setLoadingState(prev => ({ ...prev, actionLoadingId: row.ID, actionType: 'send' }));
        try {
            let linkId = row?.LINK_ID;
            let templateStr = "";
            let attachmentsArr = [];
            
            let isExpired = true;
            if (row?.LINK_ID && row?.EXPIRATION_TIME) {
                const expiryDate = moment(row.EXPIRATION_TIME, "YYYY-MM-DD h:mm:ss a");
                if (expiryDate.isValid() && expiryDate.isAfter(moment())) {
                    isExpired = false;
                }
            }

            if (isExpired) {
                const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/createOnBoardingLink`, {
                    name: row?.NAME,
                    mail: row?.MAIL,
                    intern_id: row?.ID,
                    location: row?.LOCATION,
                    type: row?.TYPE
                });
                
                linkId = response?.data?.link_id || response?.data?.LINK_ID || row?.LINK_ID;
                templateStr = response?.data?.template || "";
                attachmentsArr = response?.data?.attachments || [];
            } else {
                const configResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/getRoleConfig`);
                const roleConfig = (configResponse?.data || []).find(c => c.ROLE_NAME === (row?.TYPE || 'Employee'));
                
                if (roleConfig) {
                    let templateHtml = roleConfig.EMAIL_TEMPLATE || '';
                    templateStr = templateHtml.replace(/{{NAME}}/g, row?.NAME || '');
                    try {
                        let reqDocs = roleConfig.REQUIRED_DOCUMENTS_JSON;
                        let parsedDocs = typeof reqDocs === 'string' ? JSON.parse(reqDocs) : reqDocs || [];
                        attachmentsArr = parsedDocs.filter(doc => doc && doc.linkedFile).map(doc => doc.linkedFile);
                    } catch(e) {
                        attachmentsArr = [];
                    }
                } else {
                    templateStr = `<p>Dear ${row?.NAME},</p>
                        <p>Welcome to Data Aces.</p>
                        <p>Please review the attached forms/documents, complete the required details, and upload the completed documents using the onboarding link provided above.</p>
                        <p>Regards,<br/><br/>{{HR_NAME}}<br/>Contact No:{{HR_MOBILE}}<br/><br/>D-Aces India Private Limited</p><br/>`;
                    attachmentsArr = [];
                }
            }
            
            const { data } = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/getIntern`);
            setRows(data);
            
            const updatedRow = data.find(r => r.ID === row.ID) || row;
            linkId = linkId || updatedRow?.LINK_ID;

            const linkStr = updatedRow?.LOCATION === "US" 
                ? `${window.location.origin}/us-onboarding/${linkId}`
                : `${window.location.origin}/onboarding/${linkId}`;

            setEmailDetails({
                toEmail: updatedRow.MAIL,
                hrName: "",
                hrEmail: "",
                hrMobile: "",
                subject: "Welcome to the team! Your onboarding starts here",
                link: linkStr,
                template: templateStr,
                countryCode:"+91",
                ccEmails: []
            });
            setSelectedRow(updatedRow);
            setPreviewAttachments(attachmentsArr);
            setPreviewError("");
            setPreviewModal(true);
        } catch (error) {
            console.log(error);
            notify.error("Failed to fetch link for preview");
        } finally {
            setLoadingState(prev => ({ ...prev, actionLoadingId: null, actionType: null }));
        }
    };

    const renderEmailTemplate = () => {
        if (!emailDetails.template) return "";

        let finalHtml = emailDetails.template;
        
        finalHtml = finalHtml.replace(/{{HR_NAME}}/g, emailDetails.hrName || "HR Team");
        finalHtml = finalHtml.replace(/{{HR_EMAIL}}/g, emailDetails.hrEmail || "");
        finalHtml = finalHtml.replace(/{{HR_MOBILE}}/g, `${emailDetails.countryCode}${emailDetails.hrMobile}` || "");
        finalHtml = finalHtml.replace(
            /{{ONBOARDING_LINK}}/g,
            `<a href="${emailDetails.link}" target="_blank" rel="noopener noreferrer">
                ${emailDetails.link}
            </a>`
        );
        return finalHtml.replace(/\n/g, "<br />");
    };

    const handleSendEmail = async () => {
        if (!emailDetails.toEmail || !emailDetails.hrName || !emailDetails.hrMobile || !emailDetails.subject) {
            setPreviewError("Please fill all required fields");
            return;
        }
        setPreviewError("");
        setLoadingState(prev => ({ ...prev, emailSending: true }));
        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/sendOnboardingEmail`, {
                intern_id: selectedRow?.ID,
                toEmail: emailDetails.toEmail,
                ccEmails: emailDetails.ccEmails,
                subject: emailDetails.subject,
                htmlMessage: renderEmailTemplate(),
                type: selectedRow?.TYPE
            });
            notify.success("Email sent successfully!");
            setPreviewModal(false);
            getQueries();
        } catch (error) {
            console.log(error);
            let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later";
            notify.error(errmsg);
        } finally {
            setLoadingState(prev => ({ ...prev, emailSending: false }));
        }
    };

    const InternOffer = async (link_id) => {
        try {
            var data = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/getCandidate`, { params: { token: link_id } })
            const degrees = data.data[0];

            // Helper to extract college from comma-separated string
            const extractCollege = (degreeStr) => {
            if (!degreeStr || degreeStr.trim() === ",,,") return null;
            const parts = degreeStr.split(",");
            return parts[2]?.trim() || null;
            };
               // Priority: PG > UG
            const pgCollege =
            extractCollege(degrees.PG_DEGREE_3) ||
            extractCollege(degrees.PG_DEGREE_2) ||
            extractCollege(degrees.PG_DEGREE_1);

            const ugCollege =
            extractCollege(degrees.UG_DEGREE_3) ||
            extractCollege(degrees.UG_DEGREE_2) ||
            extractCollege(degrees.UG_DEGREE_1);

            const collegeName = pgCollege || ugCollege || "";
           var data = {
                Name: data.data[0].Name,
                valid: data.data[0].validDate,
                collegename: collegeName,
                startdate: "",
                enddate: "",
            }
            if (onNavigateToLetter) {
                onNavigateToLetter({ type: 'internOfferLetter', data: data });
            }
        } catch (error) {
            notify.error("Something went wrong, please try again later")
        }
    }


    const EmpOfferLetter = async (link_id) => {
        try {
            var response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/getCandidate`, { params: { token: link_id } })
            var data = {
                Name: response.data[0].Name,
                valid: response.data[0].validDate,
                designation: response.data[0].Designation,
                ctc: response.data[0].CTC,
                address1: response.data[0].Location,
                pincode: response.data[0].pincode,
                mail: response.data[0].MAIL,
                number: response.data[0].MobileNumber,
                basic: "",
                hra: "",
                conveyance: "",
                doj: response.data[0].DATE_OF_JION,
                medical: "",
                sp: "",
                pf: "",
                graduity: "",
                bonus: "",
                total: "",
                Gender: response?.data[0]?.Gender || ""
            }
            if (onNavigateToLetter) {
                onNavigateToLetter({ type: 'offerLetter', data: data });
            }
        } catch (error) {
            notify.error("Something went wrong, please try again later")
        }
    }

    const ProOfferLetter = async (link_id) => {
        try {
            var data = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/getCandidate`, { params: { token: link_id } })
            const degrees = data.data[0];

            // Helper to extract college from comma-separated string
            const extractCollege = (degreeStr) => {
            if (!degreeStr || degreeStr.trim() === ",,,") return null;
            const parts = degreeStr.split(",");
            return parts[2]?.trim() || null;
            };

            // Priority: PG > UG
            const pgCollege =
            extractCollege(degrees.PG_DEGREE_3) ||
            extractCollege(degrees.PG_DEGREE_2) ||
            extractCollege(degrees.PG_DEGREE_1);

            const ugCollege =
            extractCollege(degrees.UG_DEGREE_3) ||
            extractCollege(degrees.UG_DEGREE_2) ||
            extractCollege(degrees.UG_DEGREE_1);

            const collegeName = pgCollege || ugCollege || "";
            var data = {
                Name: data.data[0].Name,
                valid: data.data[0].validDate,
                designation: data.data[0].Designation,
                ctc: data.data[0].CTC,
                address1: data.data[0].Location,
                pincode: data.data[0].pincode,
                mail: data?.data[0]?.MAIL,
                number: data.data[0].MobileNumber,
                doj: data.data[0].DATE_OF_JION,
                Gender: data?.data[0]?.Gender || "",
                roll: data.data[0].roll,
                collegeName: collegeName,
                degree: data.data[0]?.UG_DEGREE_1?.split(",")?.[0],
            }
            setPreview(data);
            if (onNavigateToLetter) {
                onNavigateToLetter({ type: 'provisionalOfferLetter', data: data });
            }
        } catch (error) {
            notify.error("Something went wrong, please try again later")
        }
    }

    useEffect(() => {
        setPreviewError("");
        getQueries();
    }, [])

    useEffect(() => {
        const scrollContainer = document.getElementById('main-scroll-container');
        if (scrollContainer) {
            scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [selectedCandidateDetails])

    function getNextEmpCode(empList, currentRole = 'Intern') {
    let max = 0;
    const empType = currentRole === 'Intern' ? 'I' : 'C';
    const prefix = empType;
    

    empList.filter(emp => currentRole === 'Intern' ? 
        emp.INTERN_CODE.startsWith('I') : 
        emp.INTERN_CODE.startsWith('C')).
        forEach(emp => {
        const code = emp.INTERN_CODE;
        if (!code) return;

        let numericPart;

        if (code.startsWith(prefix)) {
        numericPart = code.slice(prefix.length);
        } else {
        numericPart = code;
        }

        const num = parseInt(numericPart, 10);
        if (!isNaN(num) && num > max) {
        max = num;
        }
    });

    const nextNumber = (max + 1).toString().padStart(6, '0');
    return prefix + nextNumber;
    }

    useEffect(()=>{  
       if (rows.length > 0) {
        setState({
            ...state,
            intern_code: getNextEmpCode(rows, state.type)
        })
       } else {
        setState({
              ...state,
            intern_code: getNextEmpCode(rows, state.type)
        })
       }
    },[rows, state.type])

    const columns = [
        {
            headerName: "Code",
            field: "INTERN_CODE",
            sortable: true,
            width: 80,
            renderCell: (params) => (
                <span>{params?.row?.INTERN_CODE}</span>
            )
        }, {
            headerName: "Location",
            field: "LOCATION",
            sortable: true,
            width: 100,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <span>{params?.row?.LOCATION}</span>
            )
        }, {
            headerName: "Type",
            field: "TYPE",
            sortable: true,
            width: 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <span>{params?.row?.TYPE}</span>
            )
        }, {
            headerName: "Name",
            field: "NAME",
            sortable: true,
            width: 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <span>{params?.row?.NAME}</span>
            )
        }, {
            headerName: "Email",
            field: "EMAIL",
            sortable: true,
            width: 350,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <span>{params?.row?.MAIL}</span>
            )
        },
        {
            headerName: "Link",
            field: "LINK",
            sortable: true,
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const linkId = params.row.LINK_ID;
                const hasLink = !!linkId && String(linkId).trim() !== "";

                const copied = copiedLinks[linkId];
                const anyActionLoading = loadingState.actionLoadingId !== null && loadingState.actionLoadingId !== undefined;

                return (
                    <span
                        onClick={hasLink && !anyActionLoading ? () => handleCopyLink(params.row) : undefined}
                        style={{
                            cursor: anyActionLoading ? "not-allowed" : (hasLink ? "pointer" : "not-allowed"),
                            opacity: anyActionLoading ? 0.6 : (hasLink ? 1 : 0.35),
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        {copied ? (
                            <FiCheck size={18} color="#10B981" />
                        ) : (
                            <FiCopy
                                size={18}
                                color={hasLink ? "#6B7280" : "#68696a"}
                            />
                        )}
                    </span>
                );
            },
        },
        {
            headerName: "Actions",
            field: "actions",
            sortable: false,
            width: 250,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const isSent = params?.row?.isEmailSent === "Yes" || params?.row?.IsEmailSent === "Yes" || params?.row?.EMAIL_SENT === "Yes" || params?.row?.email_sent === 1 || params?.row?.email_sent === "Yes";
                const isVerified = params?.row?.verified === "Yes";
                const isSubmitted = params?.row?.IsSubmitted === "Yes";
                const location = params?.row?.LOCATION === "US" ? "us-" : "";
                
                const isSendLoading = loadingState.actionLoadingId === params?.row?.ID && loadingState.actionType === 'send';
                const isVerifyLoading = loadingState.actionLoadingId === params?.row?.ID && loadingState.actionType === 'verify';
                const isViewLoading = loadingState.actionLoadingId === params?.row?.ID && loadingState.actionType === 'view';
                const isLetterLoading = loadingState.actionLoadingId === params?.row?.ID && loadingState.actionType === 'letter';
                const isDeleteLoading = loadingState.actionLoadingId === params?.row?.ID && loadingState.actionType === 'delete';
                const anyActionLoading = loadingState.actionLoadingId !== null && loadingState.actionLoadingId !== undefined;

                return (
                    <div className={`flex items-center justify-start gap-4 mx-3 h-full relative ${anyActionLoading ? 'opacity-60' : ''}`}>
                        {anyActionLoading && <div className="absolute inset-0 z-10 cursor-not-allowed" title={anyActionLoading ? "Loading..." : "Another action is in progress"}></div>}
                        
                        {/* 1. Create/Resend Link */}
                        {!isVerified && (
                            <Tooltip title={isSent ? "Resend Link" : "Create Link & Send"} placement="top" arrow>
                                <span 
                                    className={`cursor-pointer transition-transform flex items-center justify-center ${isSendLoading ? 'text-blue-600' : 'hover:scale-110 text-blue-600'}`}
                                    onClick={() => !anyActionLoading && handleOpenPreview(params?.row)}
                                >
                                    {isSendLoading ? <LoaderIcon className="h-[18px] w-[18px] text-blue-600" /> : <Send size={16} />}
                                </span>
                            </Tooltip>
                        )}
                        
                        {/* 2. Verification */}
                        {isSubmitted && !isVerified && (
                            <Tooltip title="Verify Candidate" placement="top" arrow>
                                <span className={`cursor-pointer transition-transform flex items-center justify-center ${isVerifyLoading ? 'text-emerald-600' : 'hover:scale-110 text-emerald-600'}`} onClick={() => !anyActionLoading && handleVerify(params?.row)}>
                                    {isVerifyLoading ? <LoaderIcon className="h-[18px] w-[18px] text-emerald-600" /> : <CheckCircle size={16} />}
                                </span>
                            </Tooltip>
                        )}
                        {isVerified && (
                            <Tooltip title="Verified" placement="top" arrow>
                                <span className="text-emerald-500 flex items-center justify-center">
                                    <CheckCircle size={16} />
                                </span>
                            </Tooltip>
                        )}

                        {/* 3. View Files */}
                        {isSubmitted && (
                            <Tooltip title="View Files" placement="top" arrow>
                                <span className={`cursor-pointer transition-transform flex items-center justify-center ${isViewLoading ? 'text-indigo-600' : 'hover:scale-110 text-indigo-600'}`} onClick={() => !anyActionLoading && handleViewFiles(params?.row)}>
                                    {isViewLoading ? <LoaderIcon className="h-[18px] w-[18px] text-indigo-600" /> : <FileText size={16} />}
                                </span>
                            </Tooltip>
                        )}

                        {/* 4. Letter */}
                        {isVerified && (
                            <Tooltip title={
                                params?.row?.TYPE === "Intern" ? "Internship Offer" :
                                params?.row?.TYPE === "Employee" ? "Offer Letter" :
                                "Provisional Letter"
                            } placement="top" arrow>
                                <span 
                                    className={`cursor-pointer transition-transform flex items-center justify-center ${isLetterLoading ? 'text-amber-600' : 'hover:scale-110 text-amber-600'}`}
                                    onClick={() => !anyActionLoading && handleLetterClick(params?.row)}
                                >
                                    {isLetterLoading ? <LoaderIcon className="h-[18px] w-[18px] text-amber-600" /> : <FileSignature size={16} />}
                                </span>
                            </Tooltip>
                        )}

                        {/* 5. Delete */}
                        <Tooltip title="Delete Candidate" placement="top" arrow>
                            <span 
                                className={`cursor-pointer transition-transform flex items-center justify-center ${isDeleteLoading ? 'text-red-500' : 'hover:scale-110 text-red-500'}`}
                                onClick={() => !anyActionLoading && handleDeleteClickWithLoader(params?.row)}
                            >
                                {isDeleteLoading ? <LoaderIcon className="h-[18px] w-[18px] text-red-500" /> : <Trash2 size={16} />}
                            </span>
                        </Tooltip>
                    </div>
                );
            }
        }
    ];

    return (
        <div className="flex flex-col w-full space-y-3 rounded-xl">
            {selectedCandidateDetails ? (
                selectedCandidateDetails.location === "US" ? (
                    <SharedCandidateInfo 
                        token={selectedCandidateDetails.token} 
                        viewMode={selectedCandidateDetails.isViewOnly} 
                        isUS={true}
                        onBack={() => { setSelectedCandidateDetails(null); getQueries(); }} 
                    />
                ) : (
                    <SharedCandidateInfo 
                        token={selectedCandidateDetails.token} 
                        viewMode={selectedCandidateDetails.isViewOnly} 
                        isUS={false}
                        onBack={() => { setSelectedCandidateDetails(null); getQueries(); }} 
                    />
                )
            ) : (
                <>
                    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 flex flex-col">
                <div className="flex border-b border-slate-200 px-4 rounded-t-2xl">
                    <button
                        onClick={() => setActiveTab(0)}
                        className={`flex items-center gap-2 px-6 py-4 text-sm font-semibold border-b-2 transition-colors ${
                            activeTab === 0
                                ? 'border-blue-600 text-blue-600'
                                : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
                        }`}
                    >
                        <Users size={16} />
                        Candidates
                    </button>
                    <button
                        onClick={() => setActiveTab(1)}
                        className={`flex items-center gap-2 px-6 py-4 text-sm font-semibold border-b-2 transition-colors ${
                            activeTab === 1
                                ? 'border-blue-600 text-blue-600'
                                : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
                        }`}
                    >
                        <Settings size={16} />
                        Role Configurations
                    </button>
                </div>

            {activeTab === 0 && (
                <div className="p-4 xl:p-6 flex flex-col">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-2 border-b border-slate-100 pb-3">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg border border-blue-100">
                                <Users size={20} />
                            </div>
                            <div>
                                <h3 className="text-base font-bold text-slate-800">Add New Candidate</h3>
                                <p className="text-xs text-slate-500 mt-0.5">Fill details to onboard</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-3">
                            <button type="button" className="px-5 py-2 border border-slate-200 text-slate-700 rounded-lg hover:bg-slate-50 font-medium text-sm flex items-center gap-2 transition-colors shadow-sm" onClick={() => { setState(initialState); setSubmitAttempted(false); }}>
                                <Trash2 size={16} /> Clear
                            </button>
                            <button type="button" onClick={handleAddCandiate} disabled={loadingState.addCandidateLoading} className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold shadow-sm flex items-center gap-2 text-sm disabled:opacity-70 disabled:cursor-not-allowed">
                                {loadingState.addCandidateLoading ? (
                                    <><LoaderIcon /> Adding...</>
                                ) : (
                                    <><Plus size={16} /> Add Candidate</>
                                )}
                            </button>
                        </div>
                    </div>
                    {submitAttempted && (!state.Name || !state.Mail || !state.number || !state.intern_code || !state.reportingManager || !state.dateOfJoin || !state.location || !state.type) && (
                        <div className="flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-1.5 text-xs font-medium text-red-600 mb-2 w-full">
                            <CircleAlert size={16} />
                            <span>Please complete all required fields.</span>
                        </div>
                    )}
                    <form className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end [&_.MuiOutlinedInput-root]:!h-[40px]">
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Name<span className="text-red-500">*</span></label>
                            <TextField error={submitAttempted && !state.Name} size="small" type="text" name="Name" value={state.Name} placeholder="Enter Name" onChange={handleChange} required className={`w-full bg-white text-sm ${submitAttempted && !state.Name ? '[&_fieldset]:!border-red-500' : ''}`} />
                        </div>
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Personal Email<span className="text-red-500">*</span></label>
                            <TextField error={submitAttempted && !state.Mail} size="small" type="email" name="Mail" value={state.Mail} placeholder="Enter Email" onChange={handleChange} required className={`w-full bg-white text-sm ${submitAttempted && !state.Mail ? '[&_fieldset]:!border-red-500' : ''}`} />
                        </div>
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Code<span className="text-red-500">*</span></label>
                            <TextField error={submitAttempted && !state.intern_code} size="small" type="text" name="intern_code" value={state.intern_code} placeholder="Enter Candidate Code" onChange={handleChange} required disabled className="w-full bg-slate-50 text-sm" />
                        </div>
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Candidate Type<span className="text-red-500">*</span></label>
                            <Select error={submitAttempted && !state.type} displayEmpty size="small" name="type" value={state.type} onChange={handleChange} required className={`w-full bg-white text-sm ${submitAttempted && !state.type ? '[&_fieldset]:!border-red-500' : ''}`} MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}>
                                <MenuItem disabled hidden value="" sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>Select Candidate Type</MenuItem>
                                {ROLES.map(role => (
                                    <MenuItem key={role.value} value={role.value} sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>{role.label}</MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Contact Number<span className="text-red-500">*</span></label>
                            <TextField error={submitAttempted && !state.number} size="small" type="number" name="number" value={state.number} placeholder="Enter Contact Number" onChange={handleChange} required className={`w-full bg-white text-sm ${submitAttempted && !state.number ? '[&_fieldset]:!border-red-500' : ''}`} />
                        </div>
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Reporting Manager<span className="text-red-500">*</span></label>
                            <Select error={submitAttempted && !state.reportingManager} displayEmpty size="small" name="reportingManager" value={state.reportingManager} onChange={handleChange} required className={`w-full bg-white text-sm ${submitAttempted && !state.reportingManager ? '[&_fieldset]:!border-red-500' : ''}`} MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}>
                                <MenuItem disabled hidden value="" sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>Select Reporting Manager</MenuItem>
                                {MANAGERS.map(manager => (
                                    <MenuItem key={manager.value} value={manager.value} sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>{manager.label}</MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Candidate Location<span className="text-red-500">*</span></label>
                            <Select error={submitAttempted && !state.location} displayEmpty size="small" name="location" value={state.location} onChange={handleChange} required className={`w-full bg-white text-sm ${submitAttempted && !state.location ? '[&_fieldset]:!border-red-500' : ''}`} MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}>
                                <MenuItem disabled hidden value="" sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>Select Location</MenuItem>
                                {LOCATIONS.map(loc => (
                                    <MenuItem key={loc.value} value={loc.value} sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>{loc.label}</MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Starting Date<span className="text-red-500">*</span></label>
                            <TextField error={submitAttempted && !state.dateOfJoin} size="small" type="date" name="dateOfJoin" value={state.dateOfJoin} onChange={handleChange} required className={`w-full bg-white text-sm ${submitAttempted && !state.dateOfJoin ? '[&_fieldset]:!border-red-500' : ''}`} />
                        </div>
                        <div className="w-full min-w-0">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Ending Date</label>
                            <TextField size="small" type="date" name="exitDate" value={state.exitDate} onChange={handleChange} required className="w-full bg-white text-sm" />
                        </div>
                    </form>
                </div>
            )}
            
            {activeTab === 1 && (
                <ManageRoleConfigurations onSaveStateChange={(isSaving) => setLoadingState(prev => ({ ...prev, saveConfigLoading: isSaving }))} />
            )}
            </div>

            {activeTab === 0 && (
                <>
                <div className="bg-white rounded-2xl shadow-sm border border-slate-200 flex flex-col overflow-hidden">
                    <div className="p-0">
                        <CentralizedTable
                            state={{ isLoading: loadingState.pageLoading }}
                            getRowId={rows => rows.INTERN_CODE + rows.MAIL}
                            rows={rows ?? []}
                            columns={columns}
                            renderTopToolbarCustomActions={() => (
                                <div className="flex items-center gap-3 py-3">
                                <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg border border-indigo-100">
                                    <Send size={20} />
                                </div>
                                    <div>
                                        <h3 className="text-base font-bold text-slate-800 m-0">Send Onboarding Link</h3>
                                        <p className="text-xs text-slate-500 mt-0.5">Generate and send onboarding links to candidates</p>
                                    </div>
                                </div>
                            )}
                            autoHeight
                            enableColumnPinning
                            initialState={{
                                pagination: { paginationModel: { pageSize: 5, page: 0 } },
                                columnPinning: { right: ['actions'] }
                            }}
                            muiTableHeadCellProps={({ column }) => ({
                                sx: {
                                    boxShadow: 'none !important',
                                    '&::before': {
                                        boxShadow: column.id === 'actions' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important',
                                    }
                                }
                            })}
                            muiTableBodyCellProps={({ cell }) => ({
                                sx: {
                                    py: "8px",
                                    borderBottom: "1px solid #e2e8f0",
                                    px: cell.column.getIndex() === 0 ? '16px' : "3px",
                                    overflow: cell.column.id === 'actions' ? 'visible' : 'hidden',
                                    textOverflow: cell.column.id === 'actions' ? 'clip' : 'ellipsis',
                                    backgroundColor: cell.column.id === 'actions' ? '#fff !important' : 'inherit',
                                    boxShadow: 'none !important',
                                    '&::before': {
                                        boxShadow: cell.column.id === 'actions' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important',
                                    }
                                },
                            })}
                            muiTableContainerProps={{
                                sx: {
                                    minHeight: "auto",
                                    height: 'auto',
                                    flex: 1,
                                    overflow: 'auto',
                                },
                            }}
                            hideFooterSelectedRowCount
                        />
                    </div>
                </div>
                </>
            )}



            </>
            )}

            {/* Tailwind Preview Modal */}
            <TailwindModal isOpen={previewModal} toggle={() => { if(!loadingState.emailSending) setPreviewModal(false) }} maxWidth="3xl">
                <div className="flex flex-col bg-white w-full">
                    <div className="flex justify-between items-center px-6 py-4 border-b border-slate-200">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-md bg-indigo-50 flex items-center justify-center">
                                <Mail size={16} className="text-indigo-600" />
                            </div>
                            <h5 className="m-0 font-bold text-slate-900 text-lg">Review Onboarding Email</h5>
                        </div>
                        <FiX size={24} className="text-slate-400 cursor-pointer hover:text-slate-600 transition-colors" onClick={() => setPreviewModal(false)} />
                    </div>

                    <div className="p-6 overflow-y-auto max-h-[70vh]">
                        <div className="mb-4">
                            <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-2 block">GENERATED ONBOARDING LINK</label>
                            <div className="flex gap-3 h-[38px]">
                                <TextField size="small" className="flex-1 bg-slate-50" value={emailDetails.link} InputProps={{ readOnly: true }} sx={{ '& .MuiOutlinedInput-root': { height: '38px', borderRadius: '8px', fontSize: '14px' } }} />
                                <button onClick={() => {
                                    navigator.clipboard.writeText(emailDetails.link);
                                    setCopiedLinks(prev => ({ ...prev, dialog: true }));
                                    setTimeout(() => setCopiedLinks(prev => ({ ...prev, dialog: false })), 500);
                                }} className={`w-[38px] flex items-center justify-center rounded-lg transition-colors border-none ${copiedLinks['dialog'] ? 'bg-emerald-500 hover:bg-emerald-600 text-white' : 'bg-slate-100 hover:bg-slate-200 text-slate-600'}`}>
                                    {copiedLinks['dialog'] ? <FiCheck size={16} /> : <FiCopy size={16} />}
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-0">
                            <div className="col-span-1 md:col-span-2">
                                <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-2 block">TO: <span className="text-red-500">*</span></label> 
                                <TextField size="small" type="email" className="w-full bg-white" value={emailDetails.toEmail} onChange={(e) => setEmailDetails({...emailDetails, toEmail: e.target.value})} sx={{ '& .MuiOutlinedInput-root': { height: '38px', borderRadius: '8px', fontSize: '14px' } }} />
                            </div>
                            <div className="col-span-1 md:col-span-2">
                                <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-2 block">CC (OPTIONAL):</label> 
                                <Autocomplete 
                                    multiple
                                    freeSolo
                                    options={employees?.filter(emp => emp?.DESIGNATION?.toLowerCase()?.includes("hr") && emp?.EMP_WORK_EMAIL).map(emp => emp.EMP_WORK_EMAIL) || []}
                                    value={emailDetails.ccEmails || []}
                                    onChange={(event, newValue) => {
                                        setEmailDetails({...emailDetails, ccEmails: newValue});
                                    }}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                        const { inputValue } = params;
                                        const isExisting = options.some((option) => inputValue === option);
                                        if (inputValue !== '' && !isExisting) {
                                            filtered.push(inputValue);
                                        }
                                        return filtered;
                                    }}
                                    renderOption={(props, option) => {
                                        const hrEmails = employees?.filter(emp => emp?.DESIGNATION?.toLowerCase()?.includes("hr") && emp?.EMP_WORK_EMAIL).map(emp => emp.EMP_WORK_EMAIL) || [];
                                        const isNew = !hrEmails.includes(option);
                                        return (
                                            <li {...props}>
                                                {isNew ? `Add "${option}"` : option}
                                            </li>
                                        );
                                    }}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip variant="outlined" label={option} {...getTagProps({ index })} size="small" />
                                        ))
                                    }
                                      slotProps={{
                                        paper: {
                                            sx: {
                                                '& .MuiAutocomplete-option': {
                                                    fontSize: '13px',
                                                },
                                            },
                                        },
                                        popper: {
                                            sx: {
                                                zIndex: 10001
                                            }
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField 
                                            {...params} 
                                            placeholder="Add CC email" 
                                            sx={{ 
                                                '& .MuiOutlinedInput-root': { 
                                                    padding: '2px 8px',
                                                    borderRadius: '8px',
                                                    fontSize:"14px",
                                                    minHeight: '38px',
                                                    '& fieldset': { borderColor: '#D1D5DB' },
                                                    '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: '1px' },
                                                    backgroundColor: '#FFFFFF',
                                                } 
                                            }} 
                                        />
                                    )}
                                />
                            </div>
                            <div>
                                <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-2 block">HR NAME: <span className="text-red-500">*</span></label>
                                <Select displayEmpty size="small" value={emailDetails.hrName} onChange={(e) => {
                                    const emp = employees.find(emp => emp.EMP_NAME === e.target.value);
                                    setEmailDetails({...emailDetails, hrName: e.target.value, hrEmail: emp ? emp.EMP_WORK_EMAIL : ""});
                                }} className="w-full bg-white" sx={{ height: '38px', borderRadius: '8px', fontSize: '14px' }} MenuProps={{ sx: { zIndex: 10001 } }}>
                                    <MenuItem value="" disabled sx={{ fontSize: '14px' }}>Select HR</MenuItem>
                                    {employees?.filter(emp => emp?.DESIGNATION?.toLowerCase()?.includes("hr"))?.map((emp, idx) => (
                                        <MenuItem key={emp.ID || emp.MAIL || idx} value={emp.EMP_NAME} sx={{ fontSize: '14px', py: 0.5 }}>{emp.EMP_NAME}</MenuItem>
                                    ))}
                                </Select>
                            </div>
                            
                            <div>
                                <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-2 block">HR EMAIL: <span className="text-red-500">*</span></label>
                                <TextField size="small" type="email" className="w-full bg-slate-50" value={emailDetails.hrEmail || ""} InputProps={{ readOnly: true }} sx={{ '& .MuiOutlinedInput-root': { height: '38px', borderRadius: '8px', fontSize: '14px' } }} />
                            </div>
                            <div>
                                <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-2 block">HR MOBILE NUMBER: <span className="text-red-500">*</span></label>
                                <div className="flex w-full items-center border border-[#c4c4c4] hover:border-slate-800 rounded-lg overflow-hidden bg-white h-[38px] focus-within:border-blue-500 focus-within:!border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 transition-colors">
                                    <Select size="small" value={emailDetails.countryCode} onChange={(e) => setEmailDetails({...emailDetails, countryCode: e.target.value})} sx={{ height: '38px', border: 'none', '& fieldset': { border: 'none' }, fontSize: '14px', backgroundColor: 'transparent', width: '85px', boxShadow: 'none' }} MenuProps={{ sx: { zIndex: 10001 } }}>
                                        <MenuItem value="+91" sx={{ fontSize: '14px', py: 0.5 }}>+91</MenuItem>
                                        <MenuItem value="+1" sx={{ fontSize: '14px', py: 0.5 }}>+1</MenuItem>
                                        <MenuItem value="+44" sx={{ fontSize: '14px', py: 0.5 }}>+44</MenuItem>
                                        <MenuItem value="+61" sx={{ fontSize: '14px', py: 0.5 }}>+61</MenuItem>
                                        <MenuItem value="+971" sx={{ fontSize: '14px', py: 0.5 }}>+971</MenuItem>
                                        <MenuItem value="+65" sx={{ fontSize: '14px', py: 0.5 }}>+65</MenuItem>
                                    </Select>
                                    <div className="h-5 border-l border-slate-300"></div>
                                    <TextField size="small" type="tel" placeholder="Enter mobile number" className="flex-1 bg-transparent" value={emailDetails.hrMobile} onChange={(e) => setEmailDetails({...emailDetails, hrMobile: e.target.value.replace(/\D/g, '')})} sx={{ '& .MuiOutlinedInput-root': { height: '38px', border: 'none', '& fieldset': { border: 'none' }, fontSize: '14px' }, '& .MuiInputBase-input': { paddingLeft: '12px' } }} />
                                </div>
                            </div>
                            <div>
                                <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-2 block">SUBJECT: <span className="text-red-500">*</span></label>
                                <TextField size="small" type="text" className="w-full bg-white" value={emailDetails.subject} onChange={(e) => setEmailDetails({...emailDetails, subject: e.target.value})} sx={{ '& .MuiOutlinedInput-root': { height: '38px', borderRadius: '8px', fontSize: '14px' } }} />
                            </div>
                        </div>

                        <div className="mb-4 mt-4">
                            <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-2 block">MESSAGE BODY PREVIEW:</label>
                            <div className="bg-slate-50 p-5 rounded-lg border border-slate-200 min-h-[220px] text-sm text-slate-700 leading-relaxed break-words">
                                <div dangerouslySetInnerHTML={{ __html: renderEmailTemplate() }} />
                            </div>
                        </div>
                        
                        {previewAttachments && previewAttachments.length > 0 && (
                            <>
                                <label className="text-xs font-bold text-slate-900 tracking-wide uppercase mb-3 block">ATTACHMENTS:</label>
                                <div className="flex items-center flex-wrap gap-3">
                                    {previewAttachments?.map((fileName, index) => (
                                        <React.Fragment key={fileName}>
                                            <MuiLink
                                                component="button"
                                                underline="none"
                                                onClick={() => downloadFile(fileName)}
                                                sx={{
                                                    color: "#2563EB",
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    "&:hover": {
                                                        color: "#1D4ED8",
                                                        textDecoration: "underline",
                                                        textUnderlineOffset: "3px",
                                                    },
                                                }}
                                            >
                                                {fileName}
                                                <FiDownload size={14} style={{ marginLeft: "4px" }} />
                                            </MuiLink>
                                            {index < previewAttachments.length - 1 && (
                                                <div className="text-slate-300">•</div>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>

                    <div className="flex justify-between items-center px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl gap-3">
                        <div className="text-red-600 text-sm font-semibold">{previewError}</div>
                        <div className="flex gap-3">
                            <button onClick={() => setPreviewModal(false)} disabled={loadingState.emailSending} className="px-5 py-2.5 border border-slate-300 bg-white text-slate-700 rounded-lg font-semibold text-sm cursor-pointer hover:bg-slate-50 transition-colors disabled:opacity-70 disabled:cursor-not-allowed m-0">
                                Cancel
                            </button>
                            <button onClick={handleSendEmail} disabled={loadingState.emailSending} className="px-5 py-2.5 bg-blue-600 text-white border-none rounded-lg font-semibold text-sm flex items-center gap-2 cursor-pointer hover:bg-blue-700 transition-colors disabled:opacity-70 disabled:cursor-not-allowed m-0 shadow-sm">
                                {loadingState.emailSending ? (
                                    <>
                                        <div className="spinner-border spinner-border-sm" role="status" style={{ width: '14px', height: '14px' }}></div>
                                        Sending...
                                    </>
                                ) : (
                                    <>
                                        <Send size={16} /> Send Email
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </TailwindModal>
            <ActionConfirmModal 
                isOpen={deleteModalOpen} 
                onClose={() => setDeleteModalOpen(false)} 
                onConfirm={confirmDeleteCandidate} 
                title="Delete Candidate"
                message={`Are you sure you want to delete the candidate ${candidateToDelete?.NAME || ''}? This action cannot be undone.`}
                confirmText="Delete"
                type="danger"
                loading={loadingState.deleteLoading}
            />
        </div>
    )
}

export default InternHr
